import { useQuery } from "@tanstack/react-query";

import { getOrganizationReportService, getReportsSummaryService } from "@/services/reports.service";
import { OrganizationReport, OrganizationReportParams, ReportsSummary, ReportsSummaryParams } from "@/types/reports.types";

export const reportsQueryKeys = {
  all: () => ["reports"] as const,
  summary: (params: ReportsSummaryParams) => [...reportsQueryKeys.all(), "summary", params] as const,
  organization: (params: OrganizationReportParams) => [...reportsQueryKeys.all(), "organization", params] as const,
};

export const useGetReportsSummary = (params: ReportsSummaryParams = {}) =>
  useQuery<ReportsSummary, Error>({
    queryKey: reportsQueryKeys.summary(params),
    queryFn: () => getReportsSummaryService(params),
  });

export const useGetOrganizationReport = (params: OrganizationReportParams = {}) =>
  useQuery<OrganizationReport, Error>({
    queryKey: reportsQueryKeys.organization(params),
    queryFn: () => getOrganizationReportService(params),
    placeholderData: previous => previous,
  });
